import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


export interface IDetalheAposta {

    codigo?: number;
    codigo_Jogo_NBA: number;
    codigo_Usuario: number; 
    nome_Franquia_Escolhida?: string;   
    logo_Franquia_Escolhida?: string;
    codigo_Franquia_NBA?: number;
    codigo_Temporada?: number;
    codigo_Franquia_Vencedor?: number;
    margem: number;
    dtCriacao?: string;
    //codUsuCriacao: number; 

}

// export interface IListagemCidade {
//     codigo: number;
//     nome: string;
//     capital: boolean;
//     codEstado: string;

// }

export interface IDadosRetornoApostas {
    dado: IDetalheAposta[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

// export interface IDadosRetornoEdicao {
//     dado: IDetalheCidade;
//     erros: string;
//     mensagem: string;
//     processado: boolean;
//     status: number;
//     statusHTTP: number;
// }

interface RespostaCreate {
    statusHTTP: number;
    status: number;
    processado: boolean;
    erros: string;
    mensagem: string;
    dado: number;
}

export interface IDadosRetorno {
    dado: IDetalheAposta;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IFiltroAposta {
    codigo?: number| null;
    codigo_Jogo?: number| null;
    codigo_Franquia_Mandante?: string| null;
    codigo_Franquia_Visitante?: string| null;
    data_Jogo?: string| null;
}

export interface IFiltroJogos {
    codigo?: number | null;
    codigo_Jogo?: number| null;
    codigo_Franquia_Mandante?: number | null;
    codigo_Franquia_Visitante?: number | null;
    data_Inicio?: string| null;
    codigo_Usuario: number;
    quantidade_Dias: number;

}

export interface IDadosRetornoJogosNbaApostas {
    dado: IDadosJogosNbaApostas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosJogosNbaApostas {
    codigo: number;
    codigo_NBA: number;
    codigo_Franquia_NBA_Mandante: number;
    nome_Franquia_NBA_Mandante: string;
    sigla_Franquia_NBA_Mandante: string;
    logo_Franquia_NBA_Mandante: string;
    codigo_Franquia_NBA_Visitante: number;
    nome_Franquia_NBA_Visitante: string;
    sigla_Franquia_NBA_Visitante: string;
    logo_Franquia_NBA_Visitante: string;
    data_Inicio: string;
    codigo_Temporada: number;
    codUsuCriacao: number; 
    codigo_Franquia_NBA: number;
    dtCriacao: Date;
    iniciado: boolean;
    aposta: IDadosApostas
 
}

export interface IDadosApostas {
    codigo: number;
    codigo_Usuario: number;
    codigo_Jogo_NBA: number;
    codigo_Franquia_NBA: number;
    dtCriacao: Date;
    codigo_Temporada: number;
    margem: number; 
    valor: number;    
    situacao: number;
 
}

export interface IDadosRetornoClassificacao {
    dado: IDadosClassificacao[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosClassificacao {
    codigo?: number;
    codigo_Jogo_NBA: number;
    codigo_Usuario: string; 
    nome_Usuario: string;
    foto_Usuario: string;
    pontos: number;
    posicao: number; 
    codigo_Temporada?: number; 
    dtCriacao?: string;
}

export interface IDadosRetornoMinhasApostas {
    dado: IDadosMinhasApostas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosMinhasApostas {
    codigo?: number;
    codigo_Jogo_NBA: number;
    codigo_Usuario: string; 
    nome_Usuario: string;
    foto_Usuario: string;
    nome_Franquia_Mandante?: string;   
    logo_Franquia_Mandante?: string;
    codigo_Franquia_Mandante?: number;
    nome_Franquia_Visitante?: string;   
    logo_Franquia_Visitante?: string;
    codigo_Franquia_Visitante?: number;
    escolha_Mandante: boolean;
    codigo_Temporada?: number;
    situacao?: number;
    margem: number;
    data_Jogo: string;
    dtCriacao?: string;
}



const getAll = async (filtro: IFiltroAposta): Promise<IDadosRetornoApostas> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/aposta`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            codigo: filtro.codigo,
            codigo_Jogo: filtro.codigo_Jogo,
            codigo_Franquia_Mandante: filtro.codigo_Franquia_Mandante,
            codigo_Franquia_Visitante: filtro.codigo_Franquia_Visitante,
            data_Jogo: filtro.data_Jogo
        }
    });
    return data;
}

const getById = async (codigo: number): Promise<IDetalheAposta> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheAposta>(`/aposta/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data;

}


const getJogosNBAPorFiltros = async (filtro: IFiltroJogos): Promise<IDadosRetornoJogosNbaApostas> => {    
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/aposta/nba/jogos/minha`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
          params: {
            codigo: filtro.codigo,
            codigo_Usuario: filtro.codigo_Usuario,
            codigo_Jogo: filtro.codigo_Jogo,
            codigo_Franquia_Mandante: filtro.codigo_Franquia_Mandante,
            codigo_Franquia_Visitante: filtro.codigo_Franquia_Visitante,
            data_Inicio: filtro.data_Inicio,
            quantidade_Dias: filtro.quantidade_Dias
        }
    });
    return data

}

const getClassificacao = async (codigoTemporada: number): Promise<IDadosRetornoClassificacao>=>{
     const token = CookieService.get("access_token");
        const { data } = await Api.get<IDadosRetornoClassificacao>(`/aposta/classificacao/${codigoTemporada}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        }
        );
    
        return data;
}

const getMinhasApostas = async (codigoTemporada: number): Promise<IDadosRetornoMinhasApostas>=>{
     const token = CookieService.get("access_token");
       const user = CookieService.get("access_user"); // localStorage.getItem("@Auth:user");
        const { data } = await Api.get<IDadosRetornoMinhasApostas>(`/aposta/minhasapostas/${user.codUsuario}/${codigoTemporada}`, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "chavesessao": token
            }
        }
        );
    
        return data;
}



const Create = async (dados: Omit<IDetalheAposta, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post<RespostaCreate>(`/aposta`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data.dado;


}

const updateById = async (dados: IDetalheAposta): Promise<void> => {

    const token = CookieService.get("access_token");
    await Api.put<IDetalheAposta>(`/aposta`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });


}

const deleteById = async (codigo: number): Promise<void> => {

    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user"); // localStorage.getItem("@Auth:user");
    await Api.delete(`/aposta/${codigo}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

}

export const ApostaService = {

    getAll,
    getById,
    Create,
    updateById,
    deleteById, 
    getJogosNBAPorFiltros,
    getClassificacao,
    getMinhasApostas
}